import {
  RecruiterSidebarItemState,
  SidebarItemStateHandlerParams,
} from '@features/oneOnboardingAdmin/pages/NewCandidateProfilePage/CustomCandidateProfileSidebar/handlerClasses/types';

export const useContactInfo = ({
  setPageStepContext,
  flowWrapper,
  steps,
}: SidebarItemStateHandlerParams): RecruiterSidebarItemState => {
  const { page } = flowWrapper.getCurrentStepAndPage();
  const active = page === 'CONTACT_INFO';
  const completed = flowWrapper.isPageCompleted('CANDIDATE_DETAILS', 'CONTACT_INFO');
  const disabled = !(active || completed);

  return {
    active,
    disabled,
    completed,
    onClick: () => {
      const step = steps.find((x) => x.name === 'CONTACT_INFO');
      setPageStepContext({ step, page: undefined });
    },
  };
};
